// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"7c8917c9","331":"ab83f5d2","453":"eb570f4f"}[chunkId] + ".chunk.js";
};